import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { useDeletePmiById } from "api/admin/src";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const InsDeletePublicEquityIndicesDialogAction = () => {
    const dispatch = useDispatch(), [, deleteMutation] = useDeletePmiById();
    const messagesDialog = useSelector((state) => state.messagesDialog, isEqual);
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "main-delete-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: () => {
                batch(() => {
                    if (messagesDialog.customProp?.id) {
                        dispatch(deleteMutation(messagesDialog.customProp?.id, {}));
                    }
                    dispatch(closeDialog());
                });
            } }),
        React.createElement(CloseDialogButton, null));
};
